import type {Activities} from '@gaia/types';
import fetchActivities from '@gaia/utils/gaia/fetchActivities';
import {useEffect, useState} from 'react';

export default function useActivities() {
    // This hook simplifies fetching activities.json in multiple components
    const [activities, setActivities] = useState<Activities | undefined>(undefined);

    useEffect(() => {
        fetchActivities()
            .then((results) => {
                setActivities(results);
            })
            .catch(console.warn);
    }, []);

    return [activities?.activities];
}
